import { render, staticRenderFns } from "./ShowWinningTeam.vue?vue&type=template&id=1a0475a0&scoped=true&"
import script from "./ShowWinningTeam.vue?vue&type=script&lang=js&"
export * from "./ShowWinningTeam.vue?vue&type=script&lang=js&"
import style0 from "./ShowWinningTeam.vue?vue&type=style&index=0&id=1a0475a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0475a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
